
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipSimplifiedIec as ObiOwnShipSimplifiedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-simplified-iec.js';
 
 
 

 
 export const ObiOwnShipSimplifiedIec = createComponent({
   react: React,
   tagName: 'obi-own-ship-simplified-iec',
   elementClass: ObiOwnShipSimplifiedIecElement,
   events: {
     
   }
  });
 
 